export default __webpack_public_path__ + "static/media/No_Logo_Company.2f9990f8.png";